import React from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { TableBox, ButtonBasic, Tabs, InputDynamicWidth, CheckboxToggle } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import { TitlePage } from '../../components/TitlePage/TitlePage'
import useGeneralStore from '../../store/general';
import { useShallow } from 'zustand/react/shallow';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { ModalCreateCampaignFromRules } from './Modal/ModalCreateCampaignFromRules';
import { ModalLaunchHistory } from './Modal/ModalLaunchHistory/ModalLaunchHistory';
import { ModalListStrategy } from './Modal/ModalListStrategy/ModalListStrategy';
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning';
import { useResponseHandler } from '../../common/auth';
import "./Repricing.scss"

const btn_tab = [
    { label: 'Все', value: 'all' },
    { label: 'Конфликты', value: 'conflict' }
]

const Repricing = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const [pageValue, setPageValue] = useState(btn_tab[0].value)
    const {
        setIsModalNotificationsError,
        setCurrentFilterService,
        counterError,
    } = useGeneralStore(
        useShallow((state) => ({
            setIsModalNotificationsError: state.setIsModalNotificationsError,
            setCurrentFilterService: state.setCurrentFilterService,
            counterError: state.counterError
        }))
    );

    // Фильтры
    const [selectedMp, setSelectedMp] = useState([]);
    const [selectedApi, setSelectedApi] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState('');
    const [isActive, setIsActive] = useState(false)

    // Поиск
    const [search, setSearch] = useState('')
    const [dataProduct, setDataProduct] = useState(null)

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading } = setTableFuncs;

    // Modal
    const [isModalSearchData, setIsModalSearchData] = useState(null)
    const [isModal, setIsModal] = useState(false)
    const [isModalLaunchHistory, setIsModalLaunchHistory] = useState(false)
    const [currentСampaign, setCurrentСampaign] = useState(null)
    const [currentСampaignId, setCurrentСampaignId] = useState(null)


    const contextMenuArr = [
        {
            label: 'История запусков',
            onClick: (e) => {
                setCurrentСampaignId(e?.id)
                setIsModalLaunchHistory(true)
            }
        },
        {
            label: 'Удалить',
            onClick: (e) => {
                setSelectedId(e?.id)
                setIsModalDelete(true)
                if (e?.['Стратегия'] === 'Изменение цены по времени') {
                    setIsParams(true)
                }
            }
        },
    ];

    //Фильтры
    const apiFilter = () => {
        fetchApiFilterVer3({
            selectedSpace: selectedSpace?.value,
            page: apiPage,
            setApiData: setApiData,
            set: setApiData,
            searchParam: apiQuery,
            selectedApi,
            selectedShop: selectedMp,
            filter: 'api_id',
        });
    };

    useEffect(() => {
        apiFilter();
    }, [apiPage, apiQuery]);

    // Таблица
    const fetchTableData = (params, abortController = new AbortController()) => {
        setLoading(true);

        let sort, filtersParam;
        if (params) {
            [sort, filtersParam] = params;
        }

        const url = `https://apps1.ecomru.ru:4655/v1/${pageValue == 'conflict' ? 'price-tasks-conflicts' : 'price-tasks'}/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_direction=' + sort[1]
            : ''
            }`;

        const body = JSON.stringify({
            filters: filtersParam,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit,
            only_active_tasks: isActive
        });

        fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    // Удаление задачи
    const fetchDeleteСampaign = (id, selected) => {
        // console.log(selected)
        let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${id}${selected ? `?before_deletion=${selected}` : ''}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => {
                if (res.ok) {
                    setTimeout(() => fetchTableData(), 1000)
                    return res.json();
                } else {
                    throw Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => setTimeout(() => fetchTableData(), 1000))
            .catch(handleRequestError);
    }

    // Изменение статуса задачи задачи
    const fetchChangeStatusTask = (status, id) => {
        let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${id}/active-status`

        const body = JSON.stringify({
            is_active: !status
        })

        fetch(url, { method: 'PUT', headers, body })
            .then(handleTableResponse)
            .then(fetchTableData)
            .catch(handleRequestError);
    }

    // Поиск стратегий по товару
    const fetchSearchStrategy = () => {
        let url = `https://apps1.ecomru.ru:4655/v1/price-tasks-conflicts/offer-tasks?offer_id=${search}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => setDataProduct(json))
            .catch((err) => {
                console.error(err);
            });
    }

    const handleCheck = (data) => {
        fetchChangeStatusTask(data?.['Активна']?.[0], data?.['Активна']?.[1]);
    };

    useEffect(() => {
        if (!isModal) {
            paginatorRef.current.reset()
            paginatorRef.current.setTotal(0)
            const abortController = new AbortController()
            setTimeout(() => fetchTableData([], abortController), 500)
            return () => abortController.abort()
        }
    }, [isModal, pageValue, isActive]);

    // Получение всех параметров задачи
    const fetchGetСampaignInfo = (id) => {
        let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${id}`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                setCurrentСampaign(json)
                setIsModal(true)
            })
            .catch(handleRequestError);
    }

    const onActionHandler = (e) => {
        const uid = e?.['ID задачи']
        fetchGetСampaignInfo(uid)
    }

    // Модалка warning
    const [selected, setSelected] = useState(null);

    const options = [
        { value: "Вернуть цены до изменения", label: "Вернуть цены до изменения" },
        { value: "Оставить текущие цены", label: "Оставить текущие цены" }
    ];

    const handleChange = (value) => {
        setSelected(value);
    };

    const [isModalDelete, setIsModalDelete] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [isParams, setIsParams] = useState(false)

    return (
        <>
            {isModalDelete && <ModalWarning
                headerText='Подтвердите удаление'
                colorBtn={'red'}
                cancelButtonText='Отменить'
                approveButtonText='Удалить'
                onCancelClick={() => {
                    setSelectedId(null)
                    setIsParams(false)
                    setSelected(null)
                    setIsModalDelete(false)
                }}
                onApproveClick={() => {
                    fetchDeleteСampaign(selectedId, selected)
                    setSelectedId(null)
                    setIsParams(false)
                    setSelected(null)
                    setIsModalDelete(false)
                }}
                disabledApprove={!selected && isParams}
                children={
                    isParams
                        ?
                        <div className='repricing__options'>
                            {
                                options.map((option) => (
                                    <label key={option.value}>
                                        <input
                                            type="radio"
                                            name="price"
                                            value={option.value}
                                            checked={selected === option.value}
                                            onChange={() => handleChange(option.value)}
                                        />
                                        {option.label}
                                    </label>
                                ))
                            }
                        </div>
                        :
                        null
                }
            />}

            {isModal && <ModalCreateCampaignFromRules
                setIsModal={(e) => setIsModal(e)}
                currentСampaign={currentСampaign}
                setCurrentСampaign={setCurrentСampaign}
            />}

            {/* История запусков */}
            {isModalLaunchHistory && <ModalLaunchHistory
                setIsModal={setIsModalLaunchHistory}
                currentСampaignId={currentСampaignId}
                setCurrentСampaignId={setCurrentСampaignId}
            />}

            {isModalSearchData && <ModalListStrategy
                search={search}
                data={dataProduct}
                setData={setDataProduct}
                setIsModal={setIsModalSearchData}
                onAction={fetchGetСampaignInfo}
            />}

            <div className='repricing'>
                <TitlePage
                    title='Стратегии'
                />

                <div className='repricing__tabs-box'>
                    <Tabs
                        tabs={btn_tab}
                        pageValue={pageValue}
                        setPageValue={setPageValue}
                    />

                    <div className='repricing__input-box'>
                        <InputDynamicWidth
                            position='left'
                            maxWidth='100%'
                            isOpen={true}
                            onChange={setSearch}
                            placeholder='Поиск по товару'
                        />

                        <ButtonBasic
                            disabled={!search}
                            width='auto'
                            blue
                            text='Показать стратегии'
                            onClick={(e) => {
                                fetchSearchStrategy()
                                setIsModalSearchData(true)
                            }}
                        />

                        <ButtonBasic
                            red
                            width='fit-content'
                            onClick={(e) => {
                                setCurrentFilterService(13)
                                setIsModalNotificationsError(true)
                            }}
                            text={`Ошибки - ${counterError?.[13] || 0}`}
                        />
                    </div>
                </div>

                <TableBox
                    {...tableProps}
                    fetchCallback={(e) => fetchTableData(e)}
                    ref={paginatorRef}
                    paginator={true}
                    child={
                        <>
                            <ButtonBasic
                                onClick={(e) => setIsModal(true)}
                                green
                                text='Cоздать задачу'
                                size='32px'
                            />

                            <CheckboxToggle
                                text={'Только активные задачи'}
                                value={isActive}
                                onChange={setIsActive}
                            ></CheckboxToggle>
                        </>
                    }
                    onAction={onActionHandler}
                    contextMenuArr={contextMenuArr}
                    onToggle={handleCheck}
                />
            </div>
        </>
    )
}

export { Repricing }